import { PROPERTY_DOCUMENT_KIND_LABELS, type PropertyDocumentKind } from '@/shared/api';

/** Reclassify-Ziel-Kinds: alle außer der System-Kategorie AusgangsRechnung (Backend blockt reclassify_to_system_kind). */
export const RECLASSIFY_KIND_OPTIONS = (
  Object.keys(PROPERTY_DOCUMENT_KIND_LABELS) as PropertyDocumentKind[]
).filter((k) => k !== 'AusgangsRechnung');

/** Kurz-Label für das Kind-Badge in der Datei-Zeile (die vollen Labels stehen in der API-Types). */
export const PROPERTY_DOCUMENT_KIND_SHORT: Record<PropertyDocumentKind, string> = {
  Stammakte: 'Stammakte',
  Vertrag: 'Vertrag',
  Rechnung: 'Rechnung',
  AusgangsRechnung: 'Ausgangsrechnung',
  Abrechnung: 'Abrechnung',
  SteuerLaufend: 'Steuer',
  BehoerdeStamm: 'Behörde',
  WartungReparatur: 'Wartung',
  InventarListe: 'Inventar',
  Garantie: 'Garantie',
  Bedienungsanleitung: 'Anleitung',
  FotoMarketing: 'Foto',
  FotoZustand: 'Foto',
  FotoInventar: 'Foto',
  FotoSchaden: 'Foto',
  FotoReinigung: 'Foto',
  SchluesselZugang: 'Schlüssel',
  Sonstiges: 'Sonstiges',
};

/** Kinds, die serverseitig ein Beleg-Datum verlangen (mirror `RequiresIssuedOn`). */
const DATE_REQUIRED_KINDS: ReadonlySet<PropertyDocumentKind> = new Set([
  'Rechnung',
  'AusgangsRechnung',
  'Abrechnung',
  'SteuerLaufend',
  'WartungReparatur',
]);

export function requiresIssuedOn(kind: PropertyDocumentKind): boolean {
  return DATE_REQUIRED_KINDS.has(kind);
}
